<template>
  <div class="churn-description-popup-content">
    <div class="text">
      <span class="bold">אז מה זה אומר?</span>
      אנחנו
      <span class="bold coral"> נמחק לצמיתות </span>
      מהמערכת את כל המידע שקשור ל:
    </div>

    <div class="text sub">
      <div><span class="bold"> חשבונות הבנק וכרטיסי האשראי -</span>מחיקה של כל פרטי הכניסה לחשבונות כולל הסיסמאות.</div>
      <div><span class="bold"> פרטים אישיים - </span>מחיקה של כל מספרי הטלפון והשמות של כל החברים בשירות.</div>
      <div><span class="bold"> נתונים פיננסים - </span>הנתונים בתזרים כולל שינויים שבוצעו בו.</div>
      <div v-if="subscribed">
        <span class="bold"> אמצעי תשלום - </span>מחיקה של אמצעי התשלום וכל הפרטים הקשורים אליו והפסקת החיוב החודשי.
      </div>
    </div>

    <div class="text sub">
      שימו  ❤️  צוות היועצים שלנו יכול לעזור במגוון נושאים לפני שהשירות נמחק לצמיתות.
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ChurnDescriptionPopupContent',
  computed: {
    ...mapGetters('subscriptionState', ['subscribed']),
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';

  .churn-description-popup-content {
    .text {
      font-size: 16px;
      font-family: SimplerPro;
      line-height: 1.5;

      .bold {
        font-weight: bold;

        &.coral {
          color: $riseup_red;
        }
      }

      &.sub {
        margin-top: 8px;
      }
    }
  }
</style>
